import { Component, Input } from "@angular/core";
import { UserService } from "user";

@Component({
    selector: 'tyt-content-badge',
    template: `
        <ng-container *ngIf="premium && !unlocked">
            <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
            <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
        </ng-container>
        <tyt-plus-unlocked *ngIf="unlocked"></tyt-plus-unlocked>

        <tyt-full-episode-tag *ngIf="type === 'episode'"></tyt-full-episode-tag>
        <tyt-article-tag *ngIf="type === 'article'"></tyt-article-tag>

        <tyt-clip-tag *ngIf="type === 'clip'"></tyt-clip-tag>
        <tyt-podcast-tag *ngIf="type === 'podcast'"></tyt-podcast-tag>
    `,
    styles: [`
        :host {
            display: flex;
            white-space: nowrap;
        }
    `]
})
export class ContentBadgeComponent {
    constructor(
        private auth : UserService
    ) {
    }

    @Input()
    type : string;

    @Input()
    premium : boolean;

    @Input()
    unlocked : boolean;

    get audienceType() {
        return this.auth.audienceType;
    }
}